const incidentBehaviors = (() => {
  let behaviorTable, behaviorData;
  function showDeleteConfirmationPopup(message, callback) {
    const popup = POPUP.build({
      classNames: 'setupDeleteConfirmation',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const yesBtn = new Button({
      text: 'Yes',
      style: 'primary',
      styleType: 'contained',
    });
    const noBtn = new Button({
      text: 'No',
      style: 'primary',
      styleType: 'outlined',
    });

    yesBtn.onClick(e => {
      POPUP.hide(popup);
      callback(true);
    });
    noBtn.onClick(e => {
      POPUP.hide(popup);
      callback(false);
    });

    const btnWrapEle = document.createElement('div');
    btnWrapEle.classList.add('btn-wrap');
    yesBtn.renderTo(btnWrapEle);
    noBtn.renderTo(btnWrapEle);

    popup.append(messageEle);
    popup.append(btnWrapEle);

    POPUP.show(popup);
  }
  function showUnableToDeletePopup(message) {
    const popup = POPUP.build({
      classNames: 'unableToDeletePopup',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const okBtn = new Button({
      text: 'Ok',
      style: 'primary',
      styleType: 'contained',
    });
    okBtn.onClick(e => {
      POPUP.hide(popup);
    });

    popup.append(messageEle);
    okBtn.renderTo(popup);
    POPUP.show(popup);
  }
  function checkForRequiredFields(formInstance) {
    const invalidElements = [...formInstance.form.querySelectorAll(`input:invalid,select:invalid`),];
    const allElements = [...formInstance.form.querySelectorAll('input:valid, select:valid')];
    const isFormValid = Array.from(allElements).every(field => field.value && field.value.trim() !== '');

    if (invalidElements.length > 0 || !isFormValid) {
      formInstance.buttons['submit'].toggleDisabled(true);
    } else {
      formInstance.buttons['submit'].toggleDisabled(false);
    }
  }

  function showAlreadyExistsWarning(msg, form) {
    const warningPopup = POPUP.build({ hideX: true });
    warningPopup.classList.add('warning');
    const message = document.createElement('p');
    message.innerHTML = msg;
    message.style.marginBottom = '15px';
    const btnWrap = document.createElement('div');
    btnWrap.classList.add('btnWrap');
    const okBtn = button.build({
      text: 'Ok',
      type: 'contained',
      style: 'secondary',
      callback: () => {
        POPUP.hide(warningPopup);
        const overlay = document.querySelector('.overlay');
        if (overlay) overlay.classList.add('visible');
        form.buttons['cancel'].toggleDisabled(false);
      },
    });
    btnWrap.appendChild(okBtn);
    warningPopup.appendChild(message);
    warningPopup.appendChild(btnWrap);
    POPUP.show(warningPopup);
    const closeBtn = warningPopup.querySelector('.closePopupBtn');
    if (closeBtn) closeBtn.remove();
  }
  // Incident Behaviors
  //-------------------------------------------------------------------------------

  function getIncidentBehaviorView() {
    const frag = document.createDocumentFragment();

    behaviorTable = table.build({
      tableId: 'accountClassTable',
      columnHeadings: ['Type'],
      endIcon: true,
    });

    const headers = behaviorTable.querySelectorAll('.header div');
    headers[0].setAttribute('data-type', 'string');

    const addBehaviorBtnDiv = document.createElement('div');
    const addBehaviorBtn = new Button({
      text: 'ADD NEW BEHAVIOR TYPE',
      style: 'primary',
      icon: 'add',
      styleType: 'outlined',
    });

    frag.append(behaviorTable);
    if ($.session.SetupInsert) {
      addBehaviorBtn.button.style.float = 'right';
      addBehaviorBtn.renderTo(addBehaviorBtnDiv);
      frag.append(addBehaviorBtnDiv);
    }

    const tableBehaviorData = behaviorData
      .map(p => {
        return {
          values: [p.behaviorName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showBehaviorPopup(p);
          },
          endIconCallback: () => handleBehaviorDelete(p),
        };
      });

    table.populate(behaviorTable, tableBehaviorData);
    table.sortTableByHeader(behaviorTable);

    addBehaviorBtn.onClick(e => {
      showBehaviorPopup();
    });

    return frag;
  }

  // Incident Behaviors
  //-------------------------------------------------------------------------------

  function showBehaviorPopup(rowData) {
    const popup = POPUP.build({
      classNames: 'accountClassPopup',
      hideX: true,
    });

    const behaviorForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Type',
          id: 'cName',
          required: true,
        },
      ],
    });

    behaviorForm.onKeyup(() => {
      behaviorForm.inputs['cName'].setValidtyError('');
      behaviorForm.inputs['cName'].clearErrorOrWarning();
      checkForRequiredFields(behaviorForm);
    });
    behaviorForm.onChange(event => {
      behaviorForm.inputs['cName'].setValidtyError('');
      behaviorForm.inputs['cName'].clearErrorOrWarning();
      checkForRequiredFields(behaviorForm);
    });

    behaviorForm.onSubmit(async formdata => {
      const resp = (
        await _UTIL.fetchData('insertUpdateIncidentBehaviorData', {
          id: rowData ? rowData.behaviorId : 0,
          behaviorName: formdata.cName.trim(),
          userId: $.session.UserId
        })
      ).insertUpdateIncidentBehaviorDataResult;
      const newID = resp.behaviorId;
      if (newID == '-1') {
        showAlreadyExistsWarning('This behavior type already exists.', behaviorForm);
        behaviorForm.buttons['submit'].toggleDisabled(true);
        behaviorForm.buttons['cancel'].toggleDisabled(true);
      } else {
        behaviorForm.clear();
        POPUP.hide(popup);
        await getBehaviorData();
        updateBehaviorTable();
      }
    });

    behaviorForm.onCancel(event => {
      behaviorForm.clear();
      behaviorForm.buttons['submit'].toggleDisabled(true);
      POPUP.hide(popup);
    });

    behaviorForm.renderTo(popup);

    POPUP.show(popup);

    behaviorForm.populate({
      cName: rowData ? rowData.behaviorName : '',
    });

    behaviorForm.buttons['submit'].toggleDisabled(true);

    if (!$.session.SetupUpdate && rowData) {
      behaviorForm.disableFormInputs();
    }
  }

  async function handleBehaviorDelete(row) {
    const rowData = behaviorData.find(a => a.behaviorId == row.behaviorId);

    if (rowData.isAccountExistCount == 'Y') {
      showUnableToDeletePopup('This behavior type is used somewhere else in the system. It cannot be deleted.');
    } else {
      showDeleteConfirmationPopup('Are you sure you want to delete this behavior type?', async deleteRecord => {
        if (deleteRecord) {
          await _UTIL.fetchData('deleteIncidentBehaviorData', {
            token: $.session.Token,
            behaviorId: row.behaviorId,
          });

          await getBehaviorData();
          updateBehaviorTable();
        }
      });
    }
  }
  function updateBehaviorTable() {
    const tableBehaviorData = behaviorData
      .map(p => {
        return {
          values: [p.behaviorName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showBehaviorPopup(p);
          },
          endIconCallback: () => handleBehaviorDelete(p),
        };
      });

    table.populate(behaviorTable, tableBehaviorData);
  }

  async function getBehaviorData() {
    const dataBehavior = await _UTIL.fetchData('getIncidentBehavior');
    behaviorData = dataBehavior.getIncidentBehaviorResult;
  }


  // Main
  //-------------------------------------------------------------------------------
  async function getView(viewName) {
    const viewFragment = document.createDocumentFragment();
    await getBehaviorData();

    const viewHeading = document.createElement('h1');
    viewHeading.classList.add('viewHeading');
    viewHeading.textContent = 'Behaviors';

    const viewBody = document.createElement('div');
    viewBody.classList.add('viewBody');

    let viewMarkup;

    if (viewName === 'Behaviors') {
      viewMarkup = getIncidentBehaviorView();
    }

    if (viewMarkup) {
      viewFragment.append(viewHeading);
      viewFragment.append(viewBody);
      viewBody.append(viewMarkup);
    }

    return viewFragment;
  }

  return {
    getView,
  };
})();
